// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanStatementTemplate.yaml
// Generated: 2026-08-05T15:37:39.209Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanStatementTemplate, UpdatePlanStatementTemplate, PlanStatementTemplate } from '@/types/finance/PlanStatementTemplate';

/**
 * PlanStatementTemplate Service
 * CRUD operations for PlanStatementTemplate via the ABP API.
 */
export const planStatementTemplateService = new EntityService<PlanStatementTemplate, CreatePlanStatementTemplate, UpdatePlanStatementTemplate>(
  '/api/finance/planstatementtemplate',
  'PlanStatementTemplate',
);
